// extracted by mini-css-extract-plugin
export var boldText = "_7v-4";
export var checkboxContainer = "_7v-6";
export var closeIcon = "_7v-i";
export var container = "_7v-0";
export var drawer = "_7v-8";
export var drawerContent = "_7v-9";
export var extraSmallText = "_7v-5";
export var fulfillmentGroupTable = "_7v-e";
export var largeText = "_7v-3";
export var loadingSpinnerContainer = "_7v-j";
export var mediumText = "_7v-2";
export var narrow = "_7v-f";
export var notificationLink = "_7v-l";
export var packageCheckIconContainer = "_7v-7";
export var slideoutHeaderActions = "_7v-g";
export var slideoutHeaderActionsShifted = "_7v-h";
export var slideoutHeaderContainer = "_7v-a";
export var slideoutModal = "_7v-c";
export var stickyHeaderWrapper = "_7v-b";
export var table = "_7v-k";
export var tableContainer = "_7v-d";
export var tertiaryText = "_7v-1";